export const types = {
  SET_BLOGS: "SET_BLOGS",
  SAVE_BLOG: "SAVE_BLOG",
  DELETE_BLOG: "DELETE_BLOG",
};
